import { setPermissions } from './utils'

export const setChangeAgent = ({ agentPermissions }) => {
    const permission = 'feature.switchAgents'
    const hasPermission = setPermissions(agentPermissions, permission)

    return { hasPermission }
}
